export default "/images/vendor/flag-icon-css/flags/4x3/sy.svg?241b5816ff0ffd6b77075fc05bca036e";